function wrapArray(val) {
    return (Array.isArray(val) ? val : [val]).filter(e => e).map(v => v.toString())
}

export const defaultCustomFilters = () => ({
    scope: 'local',
    keyword_canal_atual: null,
    keyword_status: null,
    keyword_id_space: null,
    keyword_department_id: null,
    keyword_status_id: null,
    keyword_users_ids: null,
    number_unread_counter: null,
})

export function mergeFilters(filters, customFilters) {
    let merged = {}

    Object.keys(filters).forEach(filterKey => {
        merged[filterKey] = filters[filterKey]

        if (customFilters[filterKey]) {
            let wrappedCustomFilter = wrapArray(customFilters[filterKey])
            if (wrappedCustomFilter.length > 0) {
                merged[filterKey] = {
                    and: [wrapArray(merged[filterKey]), wrapArray(customFilters[filterKey])],
                }
            }
        }
    })

    Object.keys(customFilters).forEach(customFilterKey => {
        if (!merged[customFilterKey] && customFilters[customFilterKey]) {
            merged[customFilterKey] = customFilters[customFilterKey]
        }
    })

    return merged
}

export function roomPassAgainstFilters(room, filters, customFilters) {
    if (!room) return false

    let merged = mergeFilters(filters, customFilters)

    let reactiveFilters = {
        keyword_status: r => [wrapArray(r.status), merged.keyword_status],
        keyword_users_ids: r => [wrapArray(r.atributos_extras.users_ids), merged.keyword_users_ids],
        keyword_canal_atual: r => [wrapArray(r.canal_atual), merged.keyword_canal_atual],
        keyword_status_id: r => [wrapArray(r.status_id), merged.keyword_status_id],
        keyword_id_space: r => [wrapArray(r.id_space), merged.keyword_id_space],
        keyword_department_id: r => [wrapArray(r.department_id), merged.keyword_department_id],
        number_unread_counter: r => [
            wrapArray(r.atributos_extras.unread_counter),
            merged.number_unread_counter ? ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'] : [],
        ],
        keyword_ids_tags: r => [wrapArray(r.atributos_extras.ids_tags), merged.keyword_ids_tags],
    }

    let ignoredFilters = ['page', 'scope']

    let unsupportedFilter = Object.keys(merged).find(name => {
        if (ignoredFilters.indexOf(name) == -1) {
            return !reactiveFilters[name]
        }
    })

    // Existe um filtro que não suportamos na reatividade.
    if (unsupportedFilter) {
        return false
    }

    // Não devemos aplicar reatividade se a página for != 1
    if (filters.page !== undefined && filters.page != 1) {
        return false
    }

    for (let name in merged) {
        if (ignoredFilters.indexOf(name) !== -1) continue

        let [roomValues, filterValues] = reactiveFilters[name](room)
        let pass = false

        if (typeof filterValues == 'object' && filterValues && 'and' in filterValues) {
            pass = filterValues.and.every(subfilters => {
                return subfilters.find(value => roomValues.indexOf(value) !== -1)
            })
        } else {
            pass = wrapArray(filterValues).find(value => roomValues.indexOf(value) !== -1)
        }

        if (!pass) {
            return false
        }
    }

    return true
}
